angular.module('impactx.userlist').controller('UserRightsListCtrl', ['dataGen',
    'LoginService',
    '$securityManager',
    'selectedListItems',
    'ListPrintService',
    'ToastService',
    'ListHelperService',
    '$scope',
    '$redirect',
    'TranslationService',
    '$mdDialog',
    'ConfirmationService',
    'PartialDialogsService',
    UserRightsListController]);

function UserRightsListController(dataGen, LoginService, $securityManager, selectedListItems, ListPrintService, ToastService,
                                  ListHelperService, $scope, $redirect, TranslationService, $mdDialog, ConfirmationService,
                                  PartialDialogsService) {
    var ctrl = this;

    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.USER, "userrightlist");

    this.getMaserDataLink = function() {
        return "personaldata/" + selectedListItems.getFirstSelectedId();
    };

    this.getSettingsLink = function() {
        return "usersettings/" + selectedListItems.getFirstSelectedId();
    };

    this.getMessagesLink = function() {
        return "usermessages/" + selectedListItems.getFirstSelectedId();
    };

    this.getControlLink = function() {
        return "usercontrol/" + selectedListItems.getFirstSelectedId();
    };

    this.getGroupsLink = function() {
        return "userauthorizations/" + selectedListItems.getFirstSelectedId();
    };

    this.getDelegationLink = function() {
        return "userdelegation/" + selectedListItems.getFirstSelectedId();
    };

    this.canGhostLogin = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canLogin == 1;
    };

    this.canDelete = function() {
        if (selectedListItems.isMultiSelection()) {
            var items = selectedListItems.getSelectedItems();
            for (var i = 0; i < items.length; i++) {
                if ((items[i].canDelete !== "1" && items[i].canDelete !== 1) || items[i].deleted) {
                    return false;
                }
            }
            return true;
        }
        else {
            return false;
        }
    };

    ctrl.isDisabledUser = function(userRowData) {
        return (userRowData && (userRowData.usrstatus === '110'));
    };

    this.getAvatarShadow = function(row) {
        if(row) {
            if(ctrl.isDisabledUser(row)) {
                return '#444444 0px 0px 10px 4px';
            }

            if(row.isLoggedIn) {
                return 'red 0px 0px 10px 4px';
            }
        }

        return 'none';
    };

    this.getCellDecoration = function(name, rowData, defaultValue) {
        if(name && rowData) {
            if(name === 'avatar-shadow') {
                return ctrl.getAvatarShadow(rowData);
            }
            if(name === 'grey-image') {
                return ctrl.isDisabledUser(rowData);
            }

            return 'none';
        }
        return defaultValue;
    };

    ctrl.isDeleted = function(data) {
        return (data && data.deleted);
    };

    this.deleteUser = function(event, trns) {
        ConfirmationService.showConfirmationDialog(ctrl.deleteFinal, event,
            selectedListItems.getSelectedItems().length === 1 ? trns.confirmDeleteSingle : trns.confirmDeleteMultiple,
            trns.delete, trns.abort);
    };

    this.deleteFinal = function () {
        var dataObj;
        var resultScope = {};
        var selectedIds = selectedListItems.getSelectedIds();
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        var selectedIdsAsInteger = [];
        for (var i = 0; i < selectedIds.length; i++) {
            selectedIdsAsInteger.push(parseInt(selectedIds[i]));
        }

        if(selectedIdsAsInteger.length > 0) {

            dataGen.postAsForm(resultScope, {usrIds: selectedIdsAsInteger}, "/user/delete").then(function (data) {
                ToastService.openStandardToastAfterDeleteSuccess(resultScope, data);
                ListHelperService.refreshListData($scope, 'userRightsListCtrl', {
                    unselectRows: selectedItems
                });
            });
        }
    };

    this.canCopyUser = function() {
        return selectedListItems.isSingleSelection() && impactX.isDefined($scope, '$$childHead.data.actions.copyUser.allowed');
    };

    this.copyUser = function () {

        var resultScope = {};

        dataGen.postAsForm(resultScope, {ids: selectedListItems.getSelectedIds()}, "/user/copy").then(function () {

            if (resultScope.data.newUserIds.length === 1 && resultScope.data.newUserIds[0] > 0) {
                $redirect.redirectTo(null, '/personaldata/' + resultScope.data.newUserIds[0]);
            }
            else {
                $redirect.reload();
            }
        })
    };

    this.ghostLogin = function() {
        var dataObj = {
            targetUserId: selectedListItems.getFirstSelectedId()
        };
        dataGen.postAsForm({}, dataObj, "/ghost/login").then(function() {
            $securityManager.invalidateProcesses();
            TranslationService.refresh(dataGen);
            LoginService.refreshUI(true);
        });
    };

    this.getSecurityDataLink = function () {
        return 'securitydata/' + selectedListItems.getFirstSelectedId();
    };

    this.hasUserGroups = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().UserGroups.userGroups.length > 0;
    };

    this.toUserGroup = function (event, trns) {

        const userGroups = selectedListItems.getFirstSelectedItem().UserGroups.userGroups;

        if (userGroups.length == 1) {
            $redirect.redirectTo(null, '/usergroup/' + userGroups[0].id);
        } else {
            $mdDialog.show({
                controller: 'UserGroupSelectionController',
                controllerAs: 'userGroupSelectionController',
                templateUrl: 'modules/userlist/templates/usergroupselection-dialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    trns: trns,
                    userGroups: userGroups
                }
            });
        }
    };

    var buttonDefinition = [
        {
            label: "userGroup",
            action: ctrl.toUserGroup,
            condition: ctrl.hasUserGroups,
            process: 'EditUserGroups'
        },
        {
            label: "masterData",
            linkFunction: ctrl.getMaserDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditUser'
        },
        {
            label: "settings",
            linkFunction: ctrl.getSettingsLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditUser'
        },
        {
            label: "messages",
            linkFunction: ctrl.getMessagesLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditUser'
        },
        {
            label: "control",
            linkFunction: ctrl.getControlLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditUser'
        },
        {
            label: "groups",
            linkFunction: ctrl.getGroupsLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditUser'
        },
        {
            label: "delegation",
            linkFunction: ctrl.getDelegationLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditUser'
        },
        {label: "ghostLogin", action: ctrl.ghostLogin, condition: ctrl.canGhostLogin, process: 'GhostLogin'},
        {label: "delete", action: ctrl.deleteUser, condition: ctrl.canDelete, process: 'EditUser'},
        {label: "securityData", linkFunction: ctrl.getSecurityDataLink, type: 'link', condition: selectedListItems.isSingleSelection, process: 'SecurityData'},
        {label: "copy", action: ctrl.copyUser, condition: ctrl.canCopyUser, process: 'CopyUser'}
    ];

    this.meta = {
        rowTemplate: 'modules/userlist/templates/userrightslist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        custom: {
            getCellDecoration: this.getCellDecoration
        },
        endpoint: '/user/rights/list',
        id: 'userrightlist',
        mainAction: {id: "new", link: "#/personaldata/0", icon: "mdi-account-star"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function() {
        return this.meta;
    };

}